export default {
    "fr": {
        "Logout": "Me déconnecter",
        "Edit my avatar": "Modifier mon avatar",
        "Supported avatar": "JPG, GIF ou PNG supportés. 300 x 300 minimum.",
        "Active notifications": "Activer les notifications",
        "My profile": "Mon profil",
        "Gender": "Genre",
        "Firstname": "Prénom",
        "Lastname": "Nom",
        "Email": "Email",
        "Password": "Mot de passe",
        "Change password": "Changer le mot de passe",
        "Use a secured password": "Nous te conseillons d’utiliser un mot de passe sûr",
        "Profile updated": "Profil mis à jour"
    }
}
